module.exports = __webpack_public_path__ + "497545d5f74f20a1fbdf1e25cb6ae9cb.svg";